import get from 'transmute/get';
import { SENDER_ID, SENDER_TYPE } from '../constants/senderLocatorKeyPaths';
export const getSenderId = get(SENDER_ID);
export const getSenderType = get(SENDER_TYPE);